export default __webpack_public_path__ + "media/src/assets/images/sidebar_expand-d666d005789ed3b94408bc74b97bc890.svg";